/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useMemo, useEffect } from 'react';
import { withRouter } from 'react-router';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import { Button, Dropdown } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import RadioGroup from '@material-ui/core/RadioGroup';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
// variable custom import
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import * as commonConstant from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { TableHeaderForDetails } from './gridComponent/TableHead';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { PERCENT_ALLOWED_AMOUNT_REQ_LESS_THAN_100 } from '../../../../SharedModules/Errors/constantMessageData';
import {
  // getInvoiceDetailsByInvoiceNum,
  dispatchErrorMsgInvQtrnotPaid,
  dispatchDisplayInputField,
  getInvoiceQuarternotPaid,
} from '../store/action';
import { getInvoiceDetailsByInvoiceNum } from '../../../Display/invoice/store/actions';
import {
  getAccRecNDCSingleData,
  manufacturerArTbl,
  fldValueUpdate,
  getUnallocatedMfg,
  mfgARFirstLoad,
} from '../../../Research/AccountReceivable/MfgAccountsRec/store/actions';
import {
  getManuARForAllRpcNavFn,
  getManuARForSglRpcNavFn,
  goToArSummaryAccRecNDCSingle,
  goToMfgAccRec,
} from '../../../Research/AccountReceivable/ARCommonFunctions';
import {
  getPlanTypes,
  getMaxQtrFreezeDt,
  selectRebateList,
  selectedRebatePgm,
  selectedPlan,
} from '../../../Research/AccountReceivable/ReqAccReceivable/store/actions';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { ndcDetailFirstLoadAction } from '../../../Research/AccountReceivable/AccRecNDCDetail/store/actions';
import { NUMBER_REGEX } from '../../../../SharedModules/AppConstants';
import {dispatchInvoiceQuarterTotals, setInvoiceOtherQtrIndex, setSaveRequest} from '../../../Display/invoice/store/actions.js'
function DisplayInvoicesQtrnotPaid(props) {
  // use Selector function
  const dispatch = useDispatch();
  const history = useHistory();
  const resultList = useSelector(
    (state) => state?.sharedState?.InvoicesforQtrnotPaidReducer?.searchResult
  );
  const displayScreenData = useSelector(
    (state) => state?.sharedState?.InvoicesforQtrnotPaidReducer?.displayData
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const getErrorMsg = useSelector(
    (state) =>
      state?.sharedState?.InvoicesforQtrnotPaidReducer?.errorMsgQtrlyPayment
  );

  // variable declaration
  const gridRef = React.useRef();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [displayData, setDisplayData] = React.useState([]);
  const [payValue, setPayValue] = React.useState(displayScreenData?.payValue);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterData, setFilterData] = React.useState(
    resultList?.rebateInvoicesforQuarterNotPaidReportVO || []
  );

  useEffect(() => {
    setFilterData(resultList?.rebateInvoicesforQuarterNotPaidReportVO || []);
  }, [resultList]);
  const [checkBoxValues, setCheckBoxValues] = React.useState({
    exUnThreshMailed: displayScreenData?.exUnThreshMailed,
    incZeroURA: displayScreenData?.incZeroURA,
    excDecBalWtnOff: displayScreenData?.excDecBalWtnOff,
  });
  const [amtPercent, setAmtPercent] = React.useState(
    displayScreenData?.amtPercent
  );
  // Rebate Name with Discription
  const rebateProgramNameValue = displayScreenData.rebateProgrameName;

  // MAPPING quarter option
  const nameMapping = {
    'Bal>0': 'Balance > Zero',
    NoPayRec: 'No Payment Received',
    'Amt>PerDue': 'Amount Owed greater than of ',
  };

  // FILTERING Select option
  const getFilterData = () => {
    const allData = resultList?.rebateInvoicesforQuarterNotPaidReportVO || [];

    let filterData = [];
    if (payValue === 'Bal>0') {
      filterData = allData.filter((data) => {
        return data.balance > 0;
      });
    }
    if (payValue === 'NoPayRec') {
      filterData = allData.filter((data) => {
        return data.payments === 0;
      });
    }
    if (payValue === 'Amt>PerDue') {
      if (!isNaN(amtPercent)) {
        filterData = allData.filter((data) => {
          if (data.total != null) {
            return (
              data.amount_Due > (parseFloat(amtPercent) / 100) * data.total
            );
          }
        });
      }
    }

    // checkboxes filtering

    let exUnThreshMailed = [];
    let incZeroURA = [];
    let excDecBalWtnOff = [];
    if (
      checkBoxValues.exUnThreshMailed ||
      checkBoxValues.incZeroURA ||
      checkBoxValues.excDecBalWtnOff
    ) {
      if (checkBoxValues.exUnThreshMailed) {
        exUnThreshMailed = filterData.filter((data) => {
          return !(data.underthreshold === 1) && !(data.mailed === null);
        });
      }

      if (checkBoxValues.incZeroURA) {
        incZeroURA = filterData.filter((data) => {
          return data.non_zero_ura > 0;
        });
      }

      if (checkBoxValues.excDecBalWtnOff) {
        excDecBalWtnOff = filterData.filter((data) => {
          return ['WO', 'DB', 'DBK'].indexOf(data.status) === -1;
        });
      }

      filterData = [
        ...new Set([...exUnThreshMailed, ...incZeroURA, ...excDecBalWtnOff]),
      ];
    } else {
      filterData = [
        ...new Set([
          ...filterData,
          ...exUnThreshMailed,
          ...incZeroURA,
          ...excDecBalWtnOff,
        ]),
      ];
    }

    return filterData;
  };

  // set filtered data for checkbox nd Radio option
  React.useEffect(() => {
    const selectedRadioButton = {
      'Bal>0': 'BALANCE',
      NoPayRec: 'PAYMENTS',
      'Amt>PerDue': 'PERCENT',
    };
    const payForDetail = {
      rebateProgramCd: displayScreenData.rebateProgram,
      retainPrintQtr: displayScreenData.quarter,
      checkRadioButton: selectedRadioButton[payValue],
      includeZeroUra: checkBoxValues.incZeroURA ? 1 : 0,
      balanceWrittenOff: checkBoxValues.excDecBalWtnOff ? 1 : 0,
      underThresholdNotMailed: checkBoxValues.exUnThreshMailed ? 1 : 0,
      percentageInput: payValue === 'Amt>PerDue' ? amtPercent : null,
    };
    const filterCriteria = {
      payValue: payValue,
      amtPercent: amtPercent,
      exUnThreshMailed: checkBoxValues.exUnThreshMailed,
      incZeroURA: checkBoxValues.incZeroURA,
      excDecBalWtnOff: checkBoxValues.excDecBalWtnOff,
    };

    dispatch(getInvoiceQuarternotPaid(payForDetail, filterCriteria));

    // setFilterData(getFilterData());
  }, [
    payValue,
    amtPercent,
    checkBoxValues.exUnThreshMailed,
    checkBoxValues.incZeroURA,
    checkBoxValues.excDecBalWtnOff,
  ]);

  const handleChangePayValues = (e) => {
    dispatch(
      dispatchDisplayInputField({
        ...checkBoxValues,
        quarter: displayScreenData.quarter,
        rebateProgram: displayScreenData.rebateProgram,
        payValue: e.target.value,
      })
    );
    setPayValue(e.target.value);
  };

  const handleOnChangeChecks = (value, name) => {
    dispatch(
      dispatchDisplayInputField({
        ...checkBoxValues,
        payValue: displayScreenData.payValue,
        amtPercent: displayScreenData.amtPercent,
        quarter: displayScreenData.quarter,
        rebateProgram: displayScreenData.rebateProgram,
        [name]: value,
      })
    );
    setCheckBoxValues({
      ...checkBoxValues,
      [name]: value,
    });
  };

  // set seleceted table list
  React.useEffect(() => {
    setDisplayData(resultList);
  }, [resultList]);
  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // Navigate to Invioce page from action dropdown
  const navigateToInvoicePage = () => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs.findIndex((item) => item.navTo === '/display-invoice') === -1
    ) {
      updateTabs.push({
        navTo: '/display-invoice',
        value: 'Display Invoice',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: '/display-invoice',
    });
  };
  // Go to Display invoice screen
  const goToInvoiceDetails = async (data) => {
    // dispatch(
    //   getInvoiceDetailsByInvoiceNum({
    //     succesFunc: () => {
    //       navigateToInvoicePage();
    //     },
    //     invoiceNum: data?.invoice_num,
    //   })
    // );
    await dispatch(
      getInvoiceDetailsByInvoiceNum({ invoiceNum: data?.invoice_num })
    );
    dispatch(setInvoiceOtherQtrIndex(0))
    dispatch(dispatchInvoiceQuarterTotals([])); 
    dispatch(setSaveRequest({}));
    redirectURLLink('/display-invoice', 'Display Invoice', history, dispatch);
  };

  // Go to Account Receivable NDC details
  const handleGoToAccRecNDCDetail = async (val, disData) => {
    const reqPayload = {
      planType: disData?.planTypeCd,
      startQtr: val?.qtr,
      endQtr: val?.qtr,
      useOfficialURA: 1,
      mfgId: val && val.labeler,
      rebateProgram: disData?.displayData?.rebateProgram,
    };
    await dispatch(getManuARForSglRpcNavFn(reqPayload));
    if (val) {
      const obj = {
        mfgId: val && val.labeler,
        mfgName: val?.corp_name,
        invoiceNum: val?.invoice_num,
        invoiceDate: val?.invoice_date,
        invoiceStatus: val?.status,
        uraInfo: 'Official',
        useOfficialURA: 1,
        qtr: val.qtr,
        pgmInfo: disData?.displayData?.rebateProgram,
        pgmCd: disData?.displayData?.rebateProgram,
      };
      const payload = {
        mfgId: val?.labeler,
        startQuarter: val?.qtr,
        aiUseOfficialURA: 1,
        invoiceNumber: val?.invoice_num,
        rebateProgramCd: disData?.displayData?.rebateProgram,
      };
      const accountRecResponse = await dispatch(
        getAccRecNDCSingleData(payload, obj)
      );
      if (!_.isEmpty(accountRecResponse)) {
        dispatch(ndcDetailFirstLoadAction(false));
        goToArSummaryAccRecNDCSingle(
          history,
          disData?.displayData?.rebateProgram,
          dispatch
        );
      }
    }
  };
  // handing Go to ManufacturerDetails redirection
  const goToManufactureAccRec = async (val, disData) => {
    let payload = {
      mfgId: val && val.labeler,
      planType: disData?.planTypeCd,
      startQtr: val?.qtr,
      endQtr: disData?.orgQtr,
      useOfficialURA: 1,
    };
    let unallocatedpayload = {
      mfgId: val && val.labeler,
      planType: disData?.planTypeCd,
      startQtr: val?.qtr,
      endQtr: disData?.orgQtr,
      useOfficialURA: 1,
    };

    payload = { ...payload, rebateProgram: disData?.rebateProgram };
    const data = await dispatch(getManuARForSglRpcNavFn(payload));
    const manuFactuData = {
      [`${payload?.mfgId}-${payload?.rebateProgram}`]:
        data.accountReceivableDetailSforSingleMfgGridResponseVOs,
    };
    await dispatch(manufacturerArTbl(manuFactuData));
    unallocatedpayload = {
      ...unallocatedpayload,
      allRebateProgIndicator: 0,
      rebateProgram: disData?.rebateProgram,
    };
    await dispatch(getUnallocatedMfg(unallocatedpayload));

    const manuFactuHeaderData = {
      [`${payload?.mfgId}-${payload?.rebateProgram}`]: {
        ...disData,
        mfgName: val?.corp_name,
        pgmInfo: disData?.rebateName,
        qtrInfo: val?.qtr,
        uraInfo: 'Official',
        ...payload,
      },
    };
    await dispatch(fldValueUpdate(manuFactuHeaderData));

    await dispatch(mfgARFirstLoad(false));
    await dispatch(getPlanTypes());
    await dispatch(getMaxQtrFreezeDt());
    await dispatch(selectRebateList());
    await dispatch(selectedRebatePgm(disData?.rebateProgram));
    await dispatch(selectedPlan(disData?.planTypeCd));
    //setTimeout(() => {
      setLoading(false);
      goToMfgAccRec(history, dispatch, payload);
    //}, 2000);
    // localStorage.setItem('mfgAccRec', true);
  };

  let firstInfo = '';
  let secondInfo = '';
  let thirdInfo = '';

  let checkBoxValue = [];
  // if (checkBoxValues.exUnThreshMailed) {
  checkBoxValue.push('Exclude under Threshold/Not Mailed');
  // }
  checkBoxValue.push('Include Zero URA');
  // }
  checkBoxValue.push('Exclude Declared balanced/Written off');
  // }
  checkBoxValue = checkBoxValue.join(' ,');

  const getCheckedBoxes = [];
  if (checkBoxValues.exUnThreshMailed) {
    getCheckedBoxes.push(true);
  } else {
    getCheckedBoxes.push(false);
  }
  if (checkBoxValues.incZeroURA) {
    getCheckedBoxes.push(true);
  } else {
    getCheckedBoxes.push(false);
  }
  if (checkBoxValues.excDecBalWtnOff) {
    getCheckedBoxes.push(true);
  } else {
    getCheckedBoxes.push(false);
  }

  // To pin the total row
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : filterData;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data).toFixed(2) : '0.00';
  };

  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        action: '',
        corp_name: 'Totals',
        invoiced_Amt: sum('invoiced_Amt'),
        amount_Due: sum('amount_Due'),
        phone: '',
      });
    }
    return result;
  };

  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [filterData, filteredRows, filterApply]);

  // filter the data from row
  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };

  // pdf header
  firstInfo = payValue
    ? `${nameMapping[payValue]} ${
        payValue == 'Amt>PerDue' ? `${amtPercent} %` : ''
      } : `
    : '';
  secondInfo = checkBoxValue ? `${checkBoxValue}` : '';
  thirdInfo = rebateProgramNameValue;
  const fourthInfo = `Quarter Requested:${displayScreenData.quarter}`;

  const handleOnblurEvent = (type, value) => {
    let localErr = getErrorMsg || [];
    const data = value;
    if (
      (payValue === 'Amt>PerDue' &&
        type === 'amtPercent' &&
        isNaN(amtPercent)) ||
      parseInt(amtPercent) > 100
    ) {
      localErr = localErr.filter((item) => item.field !== 'amtPercent');
      localErr.push({
        field: 'amtPercent',
        errorType: 'required',
        message: PERCENT_ALLOWED_AMOUNT_REQ_LESS_THAN_100,
      });
    } else {
      localErr = localErr.filter((item) => item.field !== 'amtPercent');
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgInvQtrnotPaid(unique));
  };

  return (
    <div className="tBillPanel custom-check tabs-container">
      <CustomSeparator
        parent1="Summary Reports"
        parent2="Display Invoices for Quarter Not Paid"
      />
      {/* {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getErrorMsg?.length > 0
                ? _.map(getErrorMsg, (l) => l.message)
                : []
            ),
          ]}
        />
      ) : null} */}
      <Spinner load={spinnerLoader} />
      {!fullScreenView && (
        <>
          <div className="row">
            <div className="col-10">
              <div className="frr-mui-custom-form-width-45per">
                <div className="form-wrapper">
                  <div className="mui-custom-form with-select">
                    <TextField
                      id="rebate_program"
                      label="Rebate Program"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ id: 'rebate_program' }}
                      value={rebateProgramNameValue}
                    />
                  </div>
                  <div className="mui-custom-form with-select">
                    <TextField
                      id="check_by_invoice_quater"
                      label={commonConstant.quarterLabelName}
                      fullWidth
                      disabled
                      placeholder=""
                      inputProps={{ maxLength: 6 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={displayScreenData.quarter}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row ml-2 mt-2">
            <div className="col-6 pr-0 mt-1">
              <fieldset className="radioBtnGroup custom-fieldset h-100">
                <legend className="same-font-family">
                  {commonConstant.radioGroupLabelNameSelectOpt}{' '}
                </legend>

                <RadioGroup
                  className="row"
                  aria-label="gender"
                  name="gender"
                  value={payValue}
                  data-testid="INQtrP-gender"
                  onChange={handleChangePayValues}
                >
                  <FormControlLabel
                    className="row ml-2"
                    value="Bal>0"
                    control={<Radio />}
                    label="Balance > Zero"
                  />
                  <FormControlLabel
                    className="row ml-2"
                    value="NoPayRec"
                    control={<Radio />}
                    label="No Payment Received"
                  />
                  <div className="row col-10">
                    <FormControlLabel
                      style={{ marginLeft: '8px' }}
                      value="Amt>PerDue"
                      control={<Radio />}
                      label="Amount Owed greater than "
                      fullWidth
                    />
                    <TextField
                      style={{ marginLeft: '10px' }}
                      id="paginate-count"
                      label="paginate-count"
                      InputProps={{ id: 'paginate-count' }}
                      data-testid="InvoiceQtr-Paginatecount"
                      variant="filled"
                      disabled={payValue !== 'Amt>PerDue'}
                      className="searchInput input-count frr-display-hidden-label"
                      size="small"
                      value={amtPercent}
                      onChange={(e) => {
                        if (!NUMBER_REGEX.test(e.target.value)) return false;
                        setAmtPercent(e.target.value);
                        dispatch(
                          dispatchDisplayInputField({
                            ...checkBoxValues,
                            payValue: payValue,
                            quarter: displayScreenData.quarter,
                            rebateProgram: displayScreenData.rebateProgram,
                            amtPercent: e.target.value,
                          })
                        );
                      }}
                      onBlur={(e) =>
                        handleOnblurEvent('amtPercent', e.target.value)
                      }
                    />
                    <span> % of Total</span>
                  </div>
                </RadioGroup>
              </fieldset>
            </div>

            <div className="col-5 frr-checkbox-100per-width mt-3 ml-2">
              <div className="form-wrapper db" controlId="formBasicCheckbox">
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={checkBoxValues.exUnThreshMailed}
                      className=""
                    />
                  }
                  label="Exclude under Threshold/Not Mailed"
                  onChange={(e) =>
                    handleOnChangeChecks(e?.target.checked, 'exUnThreshMailed')
                  }
                />
                <FormControlLabel
                  className=""
                  control={
                    <Checkbox
                      color="primary"
                      checked={checkBoxValues.incZeroURA}
                      className=""
                    />
                  }
                  label="Include Zero URA"
                  onChange={(e) =>
                    handleOnChangeChecks(e?.target.checked, 'incZeroURA')
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={checkBoxValues.excDecBalWtnOff}
                      className=""
                    />
                  }
                  label="Exclude Declared balanced/Written off"
                  onChange={(e) =>
                    handleOnChangeChecks(e?.target.checked, 'excDecBalWtnOff')
                  }
                />
              </div>
            </div>
          </div>
        </>
      )}
      <div className="clearfix">
        <div
          id="testGrid"
          className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold"
        >
          <TableGrid
            ref={gridRef}
            rowSelection="single"
            data-testid="onEditingStopped"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={
              fullScreenView ? '70vh' : commonConstant.viewPortHeight_355
            }
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            rowData={filterData?.map((item) => {
              return {
                ...item,
              };
            })}
            columnDefs={TableHeaderForDetails}
            exportFile
            animateRows
            sideBar={false}
            isScrollOn
            hideColumnsInPdf
            fileName="InvoicesofQtrNotPaid"
            reportName="Invoices for Quarter Not Paid Report"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            onFilterData={onFilterChanged}
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 32) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
              ActionCellRender: (cellInfo) => {
                const displayScreenObj = useSelector(
                  (state) =>
                    state?.sharedState?.InvoicesforQtrnotPaidReducer
                      ?.displayData
                );
                const requestCurrentDisObj = useSelector(
                  (state) =>
                    state?.sharedState?.InvoicesforQtrnotPaidReducer
                      ?.invoicesQtrnotPaidObj?.state
                );
                if (cellInfo.data.isBottomRow) {
                  return null;
                }
                return (
                  <div className="tdCell icon-btn-group">
                    <Dropdown className="icon-dropdown-container ml-2">
                      <Dropdown.Toggle
                        className="icon-dropdown"
                        aria-label="Export"
                      >
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="action-tooltip">Action</Tooltip>
                          }
                        >
                          <SVGComponent iconName="Icon-export1" />
                        </OverlayTrigger>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="export_dropdown h-auto">
                        <Dropdown.Item
                          data-testid="export-btn"
                          role="button"
                          onClick={() =>
                            handleGoToAccRecNDCDetail(cellInfo.data, {
                              ...displayScreenObj,
                              ...requestCurrentDisObj,
                            })
                          }
                        >
                          {' '}
                          Go to Accounts Receivable NDC details
                        </Dropdown.Item>
                        <Dropdown.Item
                          role="button"
                          onClick={() => {
                            goToInvoiceDetails(cellInfo.data);
                          }}
                        >
                          {' '}
                          Go to Invoice
                        </Dropdown.Item>
                        <Dropdown.Item
                          role="button"
                          onClick={() => {
                            goToManufactureAccRec(cellInfo.data, {
                              ...displayScreenObj,
                              ...requestCurrentDisObj,
                            });
                          }}
                        >
                          {' '}
                          Go to Manufacturer Accounts Receivable
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                );
              },
            }}
            // handleViewHistory
            pinnedBottomRowData={pinnedBottomRowData}
            info={{
              firstInfo,
              secondInfo,
              thirdInfo,
              fourthInfo,
              checkbox: true,
              fifthInfo: ' ',
              getCheckedBoxes,
            }}
            getFilterApply={getFilterApply}
            // showCheckboxIcon={showCheckboxIcon},
          />
        </div>
      </div>
    </div>
  );
}
export default withRouter(DisplayInvoicesQtrnotPaid);
